module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-4-Australia-Landing-Page.30fafa8d.webp";